import angular from 'angular';
export default angular.module('grafana.core', ['ngRoute']);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./public/app/core/core_module.ts